import { cleanUrl } from '@/utils/cleanUrl'

export const slugValidation = {
  required: true,
  requiredMsg: '-',
  minLength: 2,
  minLengthMsg: 'Slug must be at least 2 characters long.',
  maxLength: 20,
  maxLengthMsg: 'Slug must not be more than 20 characters.',
  pattern: /^[a-z0-9-][a-z0-9\/-]*[a-z0-9-]$/,
  patternMsg: 'Slug must contain only lowercase letters, numbers, and hyphens.',
  fn: (value: string) => /^[^\/]*\/?[^\/]*$/.test(value),
  fnMessage: 'Slug must not contain more than 1 level of nesting.',
}

export const destinationValidation = {
  required: true,
  requiredMsg: '-',
  fn: (value: string) => !!cleanUrl(value),
  fnMessage: 'Please enter a valid URL.',
}

export const emailValidation = {
  required: true,
  requiredMsg: '-',
  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  patternMsg: 'Please enter a valid email address.',
}
